import { useStepUp } from './useStepUp';

interface RunWithStepUpOptions {
  /** Fires when the user dismisses the step-up dialog (cancel, not failure — the dialog owns its own error UI). */
  onCancel?: () => void;
}

export function useStepUpAction() {
  const { getIsValid, requestStepUp } = useStepUp();
  return async (action: () => void | Promise<void>, options?: RunWithStepUpOptions): Promise<void> => {
    if (!getIsValid()) {
      try {
        await requestStepUp();
      } catch {
        options?.onCancel?.();
        return;
      }
    }
    await action();
  };
}
